module.exports = __webpack_public_path__ + "fonts/RenaultLife-Italic.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/fonts/latin-basic/RenaultLife-Italic.ttf
// module id = 357
// module chunks = 0